














































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch,
  Ref,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import { useRouter, useFormat } from 'vivat';
import CommonProductTypeSelect from './CommonProductTypeSelect.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import getAllAreaCodes from '@/gql/areaCode/getAllAreaCodes.gql';
import createProduct from '@/gql/product/createProduct.gql';
import updateProduct from '@/gql/product/updateProduct.gql';
import getProduct from '@/gql/product/getProduct.gql';

const CommonFormWithProductCreator = defineComponent({
  components: {
    CommonProductTypeSelect,
    CommonModalWithPreset,
    PrettyCheck,
  },
  props: {
    edit: {
      default() { return false; },
    },
    id: { type: [Number, String], default: -1 },
  },
  setup(props: any) {
    const toDecimalFormat = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const NOW = new Date();
    const { route, router } = useRouter();

    const filter = reactive({
      productTypeId: undefined,
      code: undefined,
      refCode: undefined,
      productName: undefined,
      unit: undefined,
      weight: undefined,
      deliveryFee: undefined,
      width: undefined,
      length: undefined,
      height: undefined,
      productId: undefined,
    });

    const { result: getAreasDetails, loading } = useQuery(getAllAreaCodes);
    const getAreasCode = computed(() => getAreasDetails.value?.areas || []);

    const { result: getProductDetail, loading: productDetailLoading } = useQuery(getProduct, computed(() => ({ id: props.id })), () => ({ enabled: props.id !== '-1', fetchPolicy: 'network-only' }));

    watch(() => getProductDetail.value, (newVal, oldVal) => {
      if (getProductDetail?.value?.product && !productDetailLoading.value) {
        const { product } = getProductDetail?.value;
        filter.productId = product.id;
        filter.productTypeId = product.productGroup;
        filter.code = product.code;
        filter.refCode = product.refCode;
        filter.productName = product.name;
        filter.unit = product.unit;
        filter.weight = product.weightPerUnit;
        filter.deliveryFee = product.deliveryFeePerUnit;
        filter.width = product.width;
        filter.length = product.length;
        filter.height = product.height;
      }
    });

    const computedCreateProductInput = computed(() => {
      const vars = {
        code: '',
        refCode: '',
        name: '',
        unit: '',
        weightPerUnit: 0,
        deliveryFeePerUnit: 0,
        width: 0,
        length: 0,
        height: 0,
        productGroup: {
          connect: '',
        },
      };
      if (filter.code) vars.code = filter.code;
      if (filter.refCode) vars.refCode = filter.refCode;
      if (filter.productName) vars.name = filter.productName;
      if (filter.unit) vars.unit = filter.unit;
      if (filter.weight) vars.weightPerUnit = parseFloat(filter.weight);
      if (filter.deliveryFee) vars.deliveryFeePerUnit = parseFloat(filter.deliveryFee);
      if (filter.width) vars.width = parseFloat(filter.width);
      if (filter.length) vars.length = parseFloat(filter.length);
      if (filter.height) vars.height = parseFloat(filter.height);
      if (filter.productTypeId) vars.productGroup.connect = (filter.productTypeId as any)?.id || undefined;

      return vars;
    });

    const computedUpdateProductInput = computed(() => {
      const vars = {
        id: '',
        code: '',
        refCode: '',
        name: '',
        unit: '',
        weightPerUnit: 0,
        deliveryFeePerUnit: 0,
        width: 0,
        length: 0,
        height: 0,
        productGroup: {
          connect: '',
        },
      };
      if (filter.productId) vars.id = filter.productId;
      if (filter.code) vars.code = filter.code;
      if (filter.refCode) vars.refCode = filter.refCode;
      if (filter.productName) vars.name = filter.productName;
      if (filter.unit) vars.unit = filter.unit;
      if (filter.weight) vars.weightPerUnit = parseFloat(filter.weight);
      if (filter.deliveryFee) vars.deliveryFeePerUnit = parseFloat(filter.deliveryFee);
      if (filter.width) vars.width = parseFloat(filter.width);
      if (filter.length) vars.length = parseFloat(filter.length);
      if (filter.height) vars.height = parseFloat(filter.height);
      if (filter.productTypeId) vars.productGroup.connect = (filter.productTypeId as any)?.id || undefined;

      return vars;
    });

    const refetchQueries = ['getProducts'];
    const createProductMutation = useMutation(createProduct, () => ({
      variables: {
        data: computedCreateProductInput.value,
      },
      refetchQueries,
    }));
    const updateProductMutation = useMutation(updateProduct, () => ({
      variables: {
        data: computedUpdateProductInput.value,
      },
      refetchQueries,
    }));

    const computedMutation = computed(() => (
      props.edit ? updateProductMutation : createProductMutation
    ));

    const confirmModal = ref(null);
    const errorModal = ref(null);
    createProductMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'รายการเพิ่มสินค้า สำเร็จ' });
    });
    updateProductMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'รายการแก้ไขสินค้า สำเร็จ' });
    });

    createProductMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateProductMutation.onError(() => {
      (errorModal.value as any).compose();
    });

    // watch(() => getAreasDetails.value, (newVal, oldVal) => {
    //   if (newVal !== oldVal) {
    //     console.log(props.id);
    //   }
    // });
    return {
      filter,
      CommonModalWithPreset,

      createProductMutation,
      computedMutation,
      refetchQueries,

      getAreasDetails,
      getAreasCode,
      getProduct,
      createProduct,
      confirmModal,
      errorModal,

      computedCreateProductInput,
      computedUpdateProductInput,

    };
  },
});

export default CommonFormWithProductCreator;
